/**
 * Created by Mike Naughton on 10/19/17.
 *
 * A send-creation-notification operation
 */

import $ from "jquery";
import Operation from "core/models/Operation";
import session from "app/Session";

export default new Operation({
  id: "send-creation-notification",
  text: "Send Creation Notification",
  icon: "thumbs-up",
  action: function (model) {
    var deferred = new $.Deferred();

    model
      .sendCreationNotification()
      .done(function (data) {
        deferred.resolve(model, data.success);
      })
      .fail(function (jqxhr) {
        deferred.reject(jqxhr);
      });

    return deferred.promise();
  },
  available: function () {
    return session.hasRole("admin");
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/operations/send-creation-notification.js
// module id = 498
// module chunks = 1